module.exports = __webpack_public_path__ + "dcecead9b3aacd169407d211ac29ff45.svg";